module.exports = __webpack_public_path__ + "img/125555b.svg";